<template>
  <div>
    <!-- 流水清分管理 -->
    <a-card style="margin: 20px">
      <template #title>
        <div class="top-title">
          <div class="left">
            <span>流水清分管理</span>
          </div>
          <div class="right">
            <!-- 所属机构 -->
            <DepartmentChoose :department-code.sync="paramsData.departmentCode"/>

            <!--选择商户-->
            <a-select
                v-model="paramsData.merchantNo"
                allow-clear
                option-filter-prop="children"
                placeholder="请选择商户"
                show-search
                style="min-width: 300px;margin-right:50px"
            >
              <a-select-option
                  v-for="merchant in mainMerchantList"
                  :key="merchant.merchantNo"
                  :value="merchant.merchantNo"
              >
                {{ merchant.merchantName }} ({{ merchant.merchantNo }})
              </a-select-option>
            </a-select>


          </div>
        </div>
      </template>
      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="item">
          <span>批次号</span>
          <a-input v-model.trim="paramsData.batchNo" placeholder="请输入批次号" allow-clear/>
        </div>
        <div class="item">
          <span>清算流水号</span>
          <a-input v-model.trim="paramsData.settleSerialNo" placeholder="请输入清算流水号" allow-clear/>
        </div>
        <div class="item">
          <span>清算状态</span>
          <a-select v-model.trim="paramsData.settleStatus" placeholder="请选择清算状态" allow-clear>
            <a-select-option v-for="(type, value) in  commonDict.settle_status" :key="value" :value="value">
              <a-tag v-if="type.show" :color="type.color">{{ type.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>
        <div class="item">
          <span>生成时间</span>
          <a-range-picker
              v-model="generateTimeRange"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="onGenerateTimeChange"
          />
        </div>
        <div class="item">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 操作按钮区域 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button type="primary" @click="handleQuery">刷新</a-button>
        </div>
        <div class="tableBody">
          <a-table
              :columns="columns"
              :data-source="tableData"
              :pagination="false"
              :row-key="record => record.settleSerialNo"
          >
            <!-- 操作按钮 -->
            <template slot="action" slot-scope="text, record">
              <a-button-group size="small">
                <a-button icon="eye" style="color: #1890ff;" type="link" @click="viewBtn(record)" v-if="$authority('settleView')">查看</a-button>

                <a-button icon="check-circle" style="color: green" type="link" @click="settleBtn(record)" v-if="canSettle(record) && $authority('settleExecute')">
                  执行
                </a-button>
                <a-button icon="delete" style="color: red" type="link" @click="invalidlBtn(record)" v-if="canInvalid(record) && $authority('settleInvalid')">
                  作废
                </a-button>
                <a-button icon="redo" style="color: #ffbf00" type="link" @click="retryBtn(record)" v-if="retrySettle(record) && $authority('settleRetry')">
                  重试
                </a-button>
              </a-button-group>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页部分 -->
      <div class="paginationBox">
        <LcfsPagination
            :page-no.sync="pagination.pageNo"
            :page-size.sync="pagination.pageSize"
            :total="pagination.total"
            :fn="getTableData"
        />
      </div>
    </a-card>

    <!-- 清分详情弹窗 -->
    <a-modal
        v-model="viewModalVisible"
        title="清分详情"
        @cancel="viewModalVisible = false"
        width="1500px"
        :footer="null"
        :destroyOnClose="true"
    >
      <div v-if="viewData" class="settle-detail">
        <!-- 基本信息 -->
        <a-card title="清分基本信息" size="small" :bordered="false" class="detail-section">
          <a-descriptions bordered :column="3" size="small">
            <a-descriptions-item label="清算流水号">
              <span class="detail-value">{{ viewData.settleSerialNo }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="银行流水号">
              <span class="detail-value">{{ viewData.bankSerialNo }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="商户信息">
              <span class="detail-value">{{ viewData.merchantNo }} - {{ viewData.merchantName }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="清算状态">
              <a-tag :color="settle_status(viewData.settleStatus).color">{{ settle_status(viewData.settleStatus).label }}</a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="清算类型">
              <a-tag :color="viewData.settleType === '1' ? 'blue' : 'orange'">
                {{ viewData.settleType === '1' ? '自动清算' : '人工清算' }}
              </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="清算金额">
              <Balance :alignRight="false" :amount="viewData.settleAmount" prefix=" ￥ "></Balance>
            </a-descriptions-item>
            <a-descriptions-item label="待清算账户">
              <WalletInfo :accountNo="viewData.settleAccountNo" :accountName="viewData.settleAccountName" :showAccountName="true"/>
            </a-descriptions-item>
            <a-descriptions-item label="生成时间">
              <span class="detail-value">{{ formatDateTime(viewData.generateTime) }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="清算时间">
              <span class="detail-value">{{ formatDateTime(viewData.settleTime) }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="失败原因" v-if="viewData.failReason" :span="2">
              <span style="color: #ff4d4f;">{{ viewData.failReason }}</span>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>

        <!-- 清分明细 -->
        <a-card
            v-if="viewData.itemData && viewData.itemData.length > 0"
            title="清分明细"
            size="small"
            :bordered="false"
            class="detail-section"
        >
          <a-table
              :columns="detailColumns"
              :data-source="viewData.itemData"
              :pagination="false"
              size="small"
          >


          </a-table>
        </a-card>

        <div v-else class="empty-state">
          <a-empty description="暂无清分明细数据"/>
        </div>
      </div>

      <div v-else class="empty-state">
        <a-empty description="暂无清分数据"/>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import LcfsPagination from "@/view/components/LcfsPagination.vue";
import {commonDict} from "@/utils/bizDict/commonDict";
import WalletInfo from "@/view/components/WalletInfo.vue";
import Balance from '@/view/components/Balance.vue'
import DepartmentChoose from "@/view/components/DepartmentChoose.vue";

export default {
  name: 'bankFlowSettle',
  components: {DepartmentChoose, LcfsPagination, WalletInfo, Balance},
  data() {
    return {
      pagination: {pageNo: 1, pageSize: 10, total: 0},

      // 筛选参数
      paramsData: {
        bankSerialNo: "",
        settleSerialNo: "",
        batchNo: "",
        merchantNo: "",
        settleStatus: "",
        startGenerateTime: "",
        endGenerateTime: ""
      },
      generateTimeRange: [],

      // 主商户列表
      mainMerchantList: [],
      // 表格数据
      tableData: [],

      // 查看详情
      viewModalVisible: false,
      viewData: null,

      // 表格列配置
      columns: [
        {
          title: "No",
          customRender: (text, record, index) => `${(this.pagination.pageNo - 1) * this.pagination.pageSize + (index + 1)}`,
          align: "center",
          width: 60
        },
        {
          title: "批次号",
          dataIndex: "batchNo",
          align: "center",
          width: 180,
          ellipsis: true
        },
        {
          title: "清算流水号",
          dataIndex: "settleSerialNo",
          align: "center",
          width: 180,
          ellipsis: true
        },

        {
          title: "商户",
          align: "center",
          width: 150,
          customRender: (text, record) => {
            return (
                <a-tooltip>
                  <template slot="title">
                    {record.merchantNo}
                  </template>
                  {record.merchantName}
                </a-tooltip>


            );
          }
        },
        {
          title: "清算账号",
          dataIndex: "settleAccountNo",
          align: "center",
          width: 120,
          ellipsis: true,
          customRender: (text, row) => {
            if (!text) {
              return <div>-</div>
            }
            return <WalletInfo accountNo={text} accountName={row.settleAccountName} showAccountName={true}></WalletInfo>
          }
        },
        {
          title: "清算金额",
          dataIndex: "settleAmount",
          align: "center",
          width: 120,

          customRender: (text) => {
            return <Balance amount={text}></Balance>
          }
        },

        {
          title: "清算状态",
          dataIndex: "settleStatus",
          align: "center",
          width: 100,
          customRender: (text, record) => {
            if (record.settleStatus === '2') {
              return <a-popover placement="top">
                <a-tag color={this.settle_status(text).color}>{this.settle_status(text).label}</a-tag>
                <template slot="content">
                  <p>失败原因：{record.failReason}</p>

                </template>
              </a-popover>
            } else {
              return <a-tag color={this.settle_status(text).color}>{this.settle_status(text).label}</a-tag>
            }
          },
        },
        // {
        //   title: "清算类型",
        //   dataIndex: "settleType",
        //   align: "center",
        //   width: 100,
        //   customRender: (text) => {
        //     return <a-tag color={this.flowSettle_type(text).color}>{this.flowSettle_type(text).label}</a-tag>
        //   }
        // },
        {
          title: "生成时间",
          dataIndex: "generateTime",
          align: "center",
          width: 180,
          customRender: (text) => {
            return this.formatDateTime(text)
          }
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "center",
          fixed: "right",
          scopedSlots: {customRender: 'action'}
        }
      ],

      // 详情表格列配置
      detailColumns: [
        {
          title: "分账商户",
          align: "center",
          width: 180,
          customRender: (text, record) => {
            return (
                <div>
                  <div style={{fontWeight: 'bold', marginBottom: '2px', fontSize: '12px'}}>
                    {record.splitMerchantNo}
                  </div>
                  <div style={{color: '#666', fontSize: '11px'}}>
                    {record.splitMerchantName}
                  </div>
                </div>
            );
          }
        },
        {
          title: "付款账户",
          align: "center",
          dataIndex: "accountNo",
          width: 180,
          customRender: (text, row) => {
            if (!text) {
              return <div>-</div>
            }
            return <WalletInfo accountNo={text} accountName={row.accountName} showAccountName={true}></WalletInfo>
          }
        },
        {
          title: "收款账户",
          align: "center",
          dataIndex: "oppAccountNo",
          width: 180,
          customRender: (text, row) => {
            if (!text) {
              return <div>-</div>
            }
            return <WalletInfo accountNo={text} accountName={row.oppAccountName} showAccountName={true}></WalletInfo>
          }
        },
        {
          title: "清算金额",
          dataIndex: "amount",
          align: "center",
          width: 120,
          customRender: (text) => {
            return <Balance amount={text} prefix="￥"></Balance>
          }
        },
        {
          title: "清算状态",
          dataIndex: "settleStatus",
          align: "center",
          width: 100,
          customRender: (text, record) => {
            if (record.settleStatus === '2') {
              return <a-popover placement="top">
                <a-tag color={this.settle_status(text).color}>{this.settle_status(text).label}</a-tag>
                <template slot="content">
                  <p>失败原因：{record.failReason}</p>

                </template>
              </a-popover>
            } else {
              return <a-tag color={this.settle_status(text).color}>{this.settle_status(text).label}</a-tag>
            }
          },
        },
        {
          title: "钱包流水号",
          dataIndex: "walletTradeNo",
          align: "center",
          width: 180,
          ellipsis: true,
          customRender: (text) => {
            return text || '-'
          }
        },
        {
          title: "摘要",
          dataIndex: "remark",
          align: "center",
          width: 150,
          ellipsis: true,
          customRender: (text) => {
            return text || '-'
          }
        },
        {
          title: "清算时间",
          dataIndex: "settleTime",
          align: "center",
          width: 180,
          customRender: (text) => {
            return this.formatDateTime(text)
          }
        }
      ]
    };
  },
  mounted() {
    this.loadMainMerchantList();
  },
  computed: {
    commonDict() {
      return commonDict
    },
  },
  methods: {
    // 获取主商户列表
    async loadMainMerchantList() {
      try {
        const res = await this.api.settleMerchantListApi({
          merchantRelations: '1'
        });
        if (res.code === 200) {
          this.mainMerchantList = res.data || [];
          //初始化筛选参数
          if (this.mainMerchantList.length > 0) {
            this.paramsData.merchantNo = this.mainMerchantList[0]?.merchantNo;
            // 立即查询该商户的数据
            await this.getTableData();
          } else {
            this.$message.warning('暂无商户数据');
          }
        } else {
          this.$message.warning(res.info || '获取商户列表失败');
        }
      } catch (error) {
        console.error('获取商户列表失败:', error);
        this.$message.error('获取商户列表失败');
      }
    },
    // 获取表格数据
    async getTableData() {
      try {
        const res = await this.api.pageSettleApi({
          ...this.pagination,
          ...this.paramsData
        });
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.pagination.total = res.data.total || 0;
        } else {
          message.warning(res.info || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        message.error("获取数据失败");
      }
    },

    // 查询
    handleQuery() {
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    // 重置
    handleReset() {
      this.paramsData = {
        bankSerialNo: "",
        settleSerialNo: "",
        batchNo: "",
        merchantNo: "",
        settleStatus: "",
        startGenerateTime: "",
        endGenerateTime: ""
      };
      this.generateTimeRange = [];
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    // 日期范围变化
    onGenerateTimeChange(dates, dateStrings) {
      if (dates && dates.length === 2) {
        this.paramsData.startGenerateTime = dateStrings[0];
        this.paramsData.endGenerateTime = dateStrings[1];
      } else {
        this.paramsData.startGenerateTime = "";
        this.paramsData.endGenerateTime = "";
      }
    },

    // 查看详情
    async viewBtn(record) {
      try {
        const res = await this.api.getSettleDetailApi(record.settleSerialNo);
        if (res.code === 200) {
          this.viewData = res.data;
          this.viewModalVisible = true;
        } else {
          message.warning(res.info || "获取清分详情失败");
        }
      } catch (error) {
        console.error("获取清分详情失败:", error);
        message.error("获取清分详情失败");
      }
    },


    // 执行清分
    async settleBtn(record) {
      try {
        const res = await this.api.executeSettleApi(record.settleSerialNo);
        if (res.code === 200) {
          message.success("执行清分成功");
          this.getTableData();
        } else {
          message.warning(res.info || "执行清分失败");
        }
      } catch (error) {
        console.error("执行清分失败:", error);
        message.error("执行清分失败");
      }
    },


    // 作废
    async invalidlBtn(record) {
      try {
        const res = await this.api.invalidlSettleApi(record.settleSerialNo);
        if (res.code === 200) {
          message.success("作废成功");
          this.getTableData();
        } else {
          message.warning(res.info || "作废失败");
        }
      } catch (error) {
        console.error("作废失败:", error);
        message.error("作废失败");
      }
    },

    // 执行重试
    async retryBtn(record) {
      try {
        const res = await this.api.settleRetryApi(record.settleSerialNo);
        if (res.code === 200) {
          message.success("执行清分成功");
          this.getTableData();
        } else {
          message.warning(res.info || "执行清分失败");
        }
      } catch (error) {
        console.error("执行清分失败:", error);
        message.error("执行清分失败");
      }
    },


    // 判断是否可以执行清分
    canSettle(record) {
      // 根据业务逻辑，只有特定状态可以执行清分
      // 这里假设待清算状态可以执行清分
      return record.settleStatus === '0';
    },
    // 判断是否可以执行清分
    canInvalid(record) {
      // 根据业务逻辑，只有特定状态可以执行清分
      // 这里假设待清算状态可以执行清分
      return record.settleStatus === '0';
    },

    // 判断是否可以重试
    retrySettle(record) {
      return record.settleStatus === '2' || record.settleStatus === '3';
    },

    // 状态配置
    settle_status(status) {
      return commonDict.settle_status[status] || commonDict.settle_status.default;
    },

    // 状态配置
    flowSettle_type(status) {
      return commonDict.flowSettle_type[status] || commonDict.flowSettle_type.default;
    },


    // 金额格式化
    formatAmount(amount) {
      if (!amount) return '0.00';
      return parseFloat(amount).toFixed(2);
    },

    // 日期时间格式化
    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      try {
        const date = new Date(dateTime);
        return date.toLocaleString('zh-CN');
      } catch (e) {
        return dateTime;
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 24px 34px;
}

.selectBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    margin-right: 20px;

    span {
      margin-right: 8px;
      white-space: nowrap;
    }

    .ant-input {
      width: 200px;
    }

    .ant-select {
      width: 200px;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 16px;

    .ant-btn {
      margin-right: 8px;
    }
  }
}

.paginationBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.settle-detail {
  max-height: 70vh;
  overflow-y: auto;
  padding: 4px;

  .detail-section {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    /deep/ .ant-card-head {
      min-height: 40px;
      padding: 0 12px;

      .ant-card-head-title {
        font-size: 14px;
        font-weight: 600;
        padding: 8px 0;
      }
    }

    /deep/ .ant-card-body {
      padding: 12px;
    }
  }

  .detail-value {
    font-weight: 500;
    color: #333;
  }

  .empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
  }
}

@media (max-width: 768px) {
  .settle-detail {
    .detail-section {
      /deep/ .ant-descriptions-bordered .ant-descriptions-item {
        padding: 8px 12px;
      }
    }
  }
}

/deep/ .ant-descriptions-item-label {
  font-weight: bold;
  background-color: #fafafa;
}

/deep/ .ant-card-head-title {
  .top-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px;

    .dianshang {
      margin-left: 50px;
    }
  }
}
</style>